export const isNumberNotEmpty = (val) => {
  return !(
    (!isNaN(val) && val.toString().length === 0) ||
    val === null ||
    val === undefined
  );
};

export const isValidNumberStringValues = (val) => {
  return /^-?\d*\.?\d*$/.test(val);
};

export const mapCurrencyValue = (currency, value) => {
  if (value === "" || value === null || value === undefined) {
    return "";
  }
  const floatValue = parseFloat(value)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return currency ? `${currency} ${floatValue}` : floatValue;
};

export const mapOverheadCurrencyValue = (currency, value) => {
  const hasNoOverhead =
    value !== "" &&
    value !== null &&
    value !== undefined &&
    Number(value) === 0;
  return mapCurrencyValue(currency, hasNoOverhead ? null : value);
};

export const extractNumericValue = (value) => {
  return value.replace(/[^0-9.-]+/g, "");
}

export const checkNumberLength = (
  value,
  wholeLength,
  afterDecimal,
  maxValue,
  allowDecimal = false
) => {
  if (maxValue) {
    if (value.toString().split(".").length > 1 && !allowDecimal) return false;
    return parseFloat(value) > maxValue || parseFloat(value) < maxValue * -1
      ? false
      : allowDecimal && value.toString().length > wholeLength
      ? false
      : true;
  }
  if (value.toString().length > wholeLength) return false;
  return checkNumberLengthAfterDecimal(value, afterDecimal);
};

export const checkNumberLengthAfterDecimal = (
  value,
  afterDecimal
) => {
  if (afterDecimal === 0) return false;
  const numValues = value.toString().split(".");
  if (numValues.length === 1) return true;
  if (numValues[1].length > afterDecimal) return false;
  return true;
};

export const roundToDecimals = (numString, decimals = 2) => {
  const num = parseFloat(numString);
  if (isNaN(num)) return numString;
  
  // Truncate instead of rounding by using Math.floor/Math.trunc
  const multiplier = Math.pow(10, decimals);
  const truncated = Math.trunc(num * multiplier) / multiplier;
  return truncated.toFixed(decimals).toString();
};

export const getSitesAndSubjectsParameters = (parameters) => {
  if (!parameters) return [null, null];
  const sites_to_activate = getSitesParameter(parameters);
  const subjects_to_screen = getSubjectsParameter(parameters);
  return [sites_to_activate, subjects_to_screen];
};

export const getSitesParameter = (parameters) => {
  if (!parameters) return null;
  return parameters?.find(
    (param) => param.parameterName === "SITES_TO_ACTIVATE",
  );
};

export const getSubjectsParameter = (parameters) => {
  if (!parameters) return null;
  return parameters?.find(
    (param) => param.parameterName === "SUBJECTS_TO_SCREEN",
  );
};

// Check if it's a Remodel type
export const isRemodelStudyPlanType = (studyPlanTypeDetail) => {
  const REMODEL_TYPES = ["Remodel (D)", "Remodel (R)"];
  return REMODEL_TYPES.includes(studyPlanTypeDetail);
}

export const isEmpty = (value) => value === "" || value === null || value === undefined;
